import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const parametrizacaoRanqueamentoRoutes: Routes = [
  {
    path: 'parametrizacao-ranqueamento',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Parametrização de Ranqueamento',
      breadcrumb: [{ label: 'Parametrização de Ranqueamento' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./parametrizacao-ranqueamento.component').then(
            (m) => m.ParametrizacaoRanqueamentoComponent,
          ),
        data: {
          title: 'Parametrização de Ranqueamento',
          roles: [Role.PARAMETRO_RANQUEAMENTO_CONSULTAR],
          breadcrumb: [
            {
              label: 'Parametrização de Ranqueamento',
              url: '/parametrizacao-ranqueamento',
            },
          ],
        },
      },
      {
        path: ':id/configurar',
        loadComponent: () =>
          import('./parametro-ranqueamento-configurar/wizard-ranqueamento.component').then(
            (m) => m.WizardRanqueamentoComponent,
          ),
        data: {
          title: 'Configurar Parâmetro de Ranqueamento',
          roles: [Role.PARAMETRO_RANQUEAMENTO_EDITAR],
          breadcrumb: [
            {
              label: 'Parametrização de Ranqueamento',
              url: '/parametrizacao-ranqueamento',
            },
            { label: 'Configurar', url: '' },
          ],
        },
        children: [
          {
            path: '',
            redirectTo: 'ordem-processamento',
            pathMatch: 'full',
          },
          {
            path: 'ordem-processamento',
            loadComponent: () =>
              import('./parametro-ranqueamento-configurar/steps/ordem-processamento/ordem-processamento-step.component').then(
                (m) => m.OrdemProcessamentoStepComponent,
              ),
            data: {
              title: 'Ordem de Processamento',
              breadcrumb: [
                {
                  label: 'Parametrização de Ranqueamento',
                  url: '/parametrizacao-ranqueamento',
                },
                { label: 'Configurar', url: '' },
                { label: 'Ordem de Processamento', url: '' },
              ],
            },
          },
          {
            path: 'criterios-desempate',
            loadComponent: () =>
              import('./parametro-ranqueamento-configurar/steps/criterios-desempate/criterios-desempate-step.component').then(
                (m) => m.CriteriosDesempateStepComponent,
              ),
            data: {
              title: 'Critérios de Desempate',
              breadcrumb: [
                {
                  label: 'Parametrização de Ranqueamento',
                  url: '/parametrizacao-ranqueamento',
                },
                { label: 'Configurar', url: '' },
                { label: 'Critérios de Desempate', url: '' },
              ],
            },
          },
        ],
      },
    ],
  },
];
